import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_CONFIG, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { toggleDagSchedulingApi } from '@/entities/dag/api';
import type { ToggleDagSchedulingRequest } from '@/entities/dag/domain/types';

export const useToggleDagSchedulingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, ToggleDagSchedulingRequest>({
    mutationFn: (request) => toggleDagSchedulingApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });

      notification.success({
        message: NOTIFICATION_MESSAGES.DAG_STATUS_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.DAG_STATUS_UPDATE_SUCCESS_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.SUCCESS,
      });
    },
    onError: (error) => {
      console.error('Failed to update DAG scheduling state:', error);

      notification.error({
        message: NOTIFICATION_MESSAGES.DAG_STATUS_UPDATE_ERROR,
        description: NOTIFICATION_MESSAGES.DAG_STATUS_UPDATE_ERROR_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.ERROR,
      });
    },
  });
};
